import { getOrderGoodsList, getOrderGoodsInfo, editOrderGoods } from '@/api/order'

const goods = {
  state: {
    order_goods_list: []
  },

  mutations: {
    SET_ORDER_GOODS_LIST: (state, goodsList) => {
      state.order_goods_list = goodsList
    }
  },

  actions: {
    // 获取订单商品列表
    getOrderGoodsList ({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        getOrderGoodsList(payload).then((response) => {
          commit('SET_ORDER_GOODS_LIST', response.data)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取订单商品列表
    getOrderGoodsInfo ({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        getOrderGoodsInfo(payload).then((response) => {
          commit('SET_ORDER_GOODS_LIST', response.data)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 修改订单商品新价
    editOrderGoods ({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        editOrderGoods(payload).then((response) => {
          commit('SET_ORDER_GOODS_LIST', response.data)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default goods



// WEBPACK FOOTER //
// ./src/store/modules/order.js